import { v4 as uuidv4 } from 'uuid';
import ProjectImg from '../images/projectImg.png';
import CoinTrackerImg from '../images/cointracker.jpg';
import AASImg from '../images/AAS.jpg';
import ScrapoBotImg from '../images/ScrapoBot.jpg';
import IMDBImg from '../images/IMDB.png';
import HandWrittenDigitImg from '../images/HandWrittenDigit.jpg';
import InstaShellImg from '../images/InstaShell.jpg';

const projects = [
  {
    id: uuidv4(),
    name: 'Handwritten Digit Recognizer',
    desc: 'A basic Machine Learning Model to predict the handwritten digits.',
    link: 'https://github.com/Spidey03/digit_recognizer',
    img: HandWrittenDigitImg,
  },
  {
    id: uuidv4(),
    name: 'IMBD',
    desc:
      'Entertainment platform, which gives overview of film industry and evolution',
    link: 'https://github.com/Spidey03/imdb_project',
    img: IMDBImg,
  },
  {
    id: uuidv4(),
    name: 'InstaShell',
    desc:
      'InstaShell is a tool for getting user details and posts from instagram',
    link: 'https://github.com/Spidey03/insta-shell',
    img: InstaShellImg,
  },
  {
    id: uuidv4(),
    name: 'Covid 19 Dashboard',
    desc:
      'A backend application which gives analytics of Covid 19 situations in region',
    link: 'https://github.com/Spidey03/covid_19_dashboard',
    img: ProjectImg,
  },
  {
    id: uuidv4(),
    name: 'Accident Avoidance System',
    desc:
      'An IoT based prototype, using an ultrasonic sensor which detects obstacles and alert driver.',
    link: '',
    img: AASImg,
  },
  {
    id: uuidv4(),
    name: 'Scrapo Bot',
    desc:
      'A telegram bot, which is used to scrape info from web. This will helps alot for students(in progress)',
    link: 'https://github.com/Spidey03/scrapo-bot',
    img: ScrapoBotImg,
  },
  {
    id: uuidv4(),
    name: 'Todo - application',
    desc: 'A backend todo application to track and complete tasks.',
    link: 'https://github.com/Spidey03/todo',
    img: CoinTrackerImg,
  },
];

export default projects;
